import React from "react";
import { RiskMethodologyModal } from "./RiskMethodologyModal";
import { RISK_METHODOLOGY } from "./riskMethodologyContent";
import { SIGNALS_METHODOLOGY } from "./signalsMethodologyContent";

/**
 * SignalsMethodologyModal — "how to read this board" reference for the LEAPS Regime
 * Diagnostics (Signals) dashboard. Reuses the shared RiskMethodologyModal renderer with
 * Signals-specific copy (signalsMethodologyContent.ts). Presentation only — it renders
 * grounded copy in tabs and never fetches, computes, or mutates anything.
 */
export const SignalsMethodologyModal: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => (
  <RiskMethodologyModal
    open={open}
    onClose={onClose}
    content={SIGNALS_METHODOLOGY as unknown as typeof RISK_METHODOLOGY}
    titleId="signals-methodology-title"
  />
);

export default SignalsMethodologyModal;
